export enum PRODUCT_TABS {
  CONTENT = 'content',
  COMMENTS = 'reviews',
  QUESTIONS = 'comments',
  SUPPORT = 'support',
  DEVELOPER_DISCOUNT_CODES = 'developer-discount-codes',
}

export enum PRODUCT_TYPE {
  READY_SITE = 'ready-site',
}

export enum MARKETS {
  BUNDLE = 'Bundle',
  PRODUCT = 'Web',
  ACADEMY = 'Academy',
}

export enum SOCIAL_MEDIA_TYPE {
  LINKEDIN = 'linkedin',
  WHATSAPP = 'whatsapp',
  TWITTER = 'twitter',
  TELEGRAM = 'telegram',
}

export enum VOTE {
  LIKE = 'like',
  DISLIKE = 'dislike',
}
